function headerOnScroll() {
	let scroll = $(window).scrollTop();
	let headerTopContentHeight = $(
		`.o-header__top-content-wrapper`,
	).outerHeight();
	let windowWidth = $(window).outerWidth();

	if (scroll >= headerTopContentHeight && windowWidth >= 1024) {
		$(`.o-header`).addClass(`o-header--onscroll`);
	} else {
		$(`.o-header`).removeClass(`o-header--onscroll`);
	}
}

function header() {
	$(document).ready(headerOnScroll);
	$(window).scroll(headerOnScroll);
}

export default header;
